
// Generated by common/web/keyman-version/build.sh
//
// Note:  does not use the 'default' keyword so that the export name is
// correct when converted to a CommonJS module with `esbuild`.
export class KEYMAN_VERSION {
  static readonly VERSION = "19.0.180";
  static readonly VERSION_RELEASE ="19.0";
  static readonly VERSION_MAJOR = "19";
  static readonly VERSION_MINOR = "0";
  static readonly VERSION_PATCH = "180";
  static readonly TIER ="alpha";
  static readonly VERSION_TAG = "-alpha";
  static readonly VERSION_WITH_TAG = "19.0.180-alpha";
  static readonly VERSION_ENVIRONMENT = "alpha";
  static readonly VERSION_GIT_TAG = "release@19.0.180-alpha";
}

// Also provides it as a 'default' export.
export default KEYMAN_VERSION;
  
